
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_181ke_17",
  "full-width": "awsui_full-width_8cbea_181ke_44",
  "refresh": "awsui_refresh_8cbea_181ke_47",
  "disabled": "awsui_disabled_8cbea_181ke_53",
  "selected": "awsui_selected_8cbea_181ke_116",
  "icon": "awsui_icon_8cbea_181ke_128",
  "with-text": "awsui_with-text_8cbea_181ke_132",
  "with-no-text": "awsui_with-no-text_8cbea_181ke_141",
  "root": "awsui_root_8cbea_181ke_146",
  "segment-part": "awsui_segment-part_8cbea_181ke_178",
  "grouped": "awsui_grouped_8cbea_181ke_203",
  "grouped-only": "awsui_grouped-only_8cbea_181ke_203",
  "grouped-vertical": "awsui_grouped-vertical_8cbea_181ke_207",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_8cbea_181ke_222",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_8cbea_181ke_226",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_8cbea_181ke_232",
  "grouped-vertical-first": "awsui_grouped-vertical-first_8cbea_181ke_236",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_8cbea_181ke_240",
  "grouped-vertical-last": "awsui_grouped-vertical-last_8cbea_181ke_246",
  "grouped-with-action": "awsui_grouped-with-action_8cbea_181ke_250",
  "with-error": "awsui_with-error_8cbea_181ke_254",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_8cbea_181ke_282",
  "grouped-vertical-only": "awsui_grouped-vertical-only_8cbea_181ke_282",
  "with-warning": "awsui_with-warning_8cbea_181ke_288",
  "grouped-validation-first": "awsui_grouped-validation-first_8cbea_181ke_330",
  "select": "awsui_select_8cbea_181ke_116",
  "segment-count-2": "awsui_segment-count-2_8cbea_181ke_352",
  "segment-count-3": "awsui_segment-count-3_8cbea_181ke_359",
  "segment-count-4": "awsui_segment-count-4_8cbea_181ke_366",
  "segment-count-5": "awsui_segment-count-5_8cbea_181ke_373",
  "segment-count-6": "awsui_segment-count-6_8cbea_181ke_380",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_181ke_387"
};
  